export default "__VITE_ASSET__62e432ed__"